export default {
  ADD_ITEM (state, item) {
    state.users.unshift(item)
  },
  SET_USERS (state, users) {
    state.users = users
  },
  UPDATE_USERS (state, user) {
    const userIndex = state.users.findIndex((p) => p.id === user.id)
    Object.assign(state.users[userIndex], user)
  }
}
